import { IFilterOptions } from '@quadminds/shared/commons';

export interface IProductAudit {
    userId?: string;
    userName?: string;
    timestamp: string;
}

export interface ICreateProductDto {
    code: string;
    description: string;
    active?: boolean;
}

export type IUpdateProductDto = Partial<ICreateProductDto>;

export interface IProductOutputDto {
    id: string;
    code: string;
    description: string;
    active: boolean;
    createdBy?: IProductAudit;
    updatedBy?: IProductAudit;
    createdAt?: string;
    updatedAt?: string;
}

export interface IGetProductsFilters extends IFilterOptions {
    /** Partial, case-insensitive match on code or description. */
    search?: string;
    active?: boolean;
}
